module.exports = __webpack_public_path__ + "static/media/heartFilled.88a5ca56.svg";